import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const MusicLogo = styled("img")(({ theme }) => ({
  width: 89,
  [theme.breakpoints.up("mobile")]: {
    width: 110,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 195,
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 13,
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 23,
  },
}));

export const Info = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "spacing",
})(({ theme, spacing }) => ({
  marginBottom: spacing ? 75 : 19,
  padding: 0,
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.large.fontSize,
  },
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 50,
  },
}));

export const CardContainer = styled("div")({
  alignSelf: "center",
});
